export default __webpack_public_path__ + "static/media/mathias_m.747aabf3.jpg";